import React from "react";
import { Pressable } from "native-base";
import { getHitSlop } from "@huum/utils/hitSlop";
export const Touchable = (props) => {
    const { children, onPress, ...rest } = props;
    return (<Pressable hitSlop={getHitSlop(8)} _pressed={{ opacity: 0.8 }} onPress={onPress} {...rest}>
      {children}
    </Pressable>);
};
